/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { DateTime } from '@app/shared/models/date-time.model';
import { User } from '@app/settings/users/user.model';

export class Activity extends Model {
  id: number;
  log_name: string;
  description: string;
  created_at: DateTime;
  properties: { attributes: {}; old: {} };
  causer: User;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.causer) {
      this.causer = new User().deserialize(input.causer);
    }

    return this;
  }

  getKeys(): Array<string> {
    if (!this.isModelActivity()) {
      return [];
    }
    return Object.keys(this.properties.old);
  }

  getOldValue(key: string): string {
    return this.properties.old[key];
  }

  getNewValue(key: string): string {
    return this.properties.attributes[key];
  }

  isModelActivity(): boolean {
    if (!this.properties.old) {
      return false;
    }
    return true;
  }
}
